<div class="dialog">
  @if (getCustomerInfoLoading()) {
    <div class="loading-overlay">
      <mat-progress-spinner mode="indeterminate" diameter="40" />
    </div>
  }

  <div class="dialog__header">
    <h1>{{ 'customers.viewCustomer.title' | translate }}</h1>
    <button mat-icon-button (click)="onClose()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-tabs [tabs]="tabs" [(activeTab)]="activeTab" />

  @if (!getCustomerInfoLoading() && customerInfo()) {
    @switch (activeTab()) {
      @case ('info') {
        <app-customer-info-section [customerInfo]="customerInfo()" (closeDialog)="onClose()" />
      }

      @case ('history') {
        <app-customer-order-history-section
          [customerInfo]="customerInfo()"
          (closeDialog)="onClose()"
        />
      }
    }
  }
</div>
